import React from "react";

interface IProps extends React.ParamHTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
  className?: string;
  props?: any;
  fontFamily?:
    | "Poppins-Medium"
    | "Poppins-Regular"
    | "Poppins-Bold"
    | "Poppins-SemiBold";
}

const RenderText : React.FC<IProps> = ({ children, className, fontFamily, ...props }) => {

  const fontClass = fontFamily ? `font-${fontFamily}` : "";

  return (
    <p className={`${fontClass} ${className}`} {...props}>
      {children}
    </p>
  );
};
  
export default RenderText;
